import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    Typography
} from "@mui/material";

import axios from "axios";
import { useEffect, useState } from "react";
import { configUrl } from "../config";
import applyCouponService from "../services/applyCouponService";

const CheckoutPage = ({ course, isFreeSubscription, onProceedToPayment, CPFiltersValues, name, email, mobile }) => {
    console.log("the isFreeSubscription", isFreeSubscription);
    const [coupon, setCoupon] = useState("");
    const [couponID, setCouponID] = useState(null);
    const [discount, setDiscount] = useState(0);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isCPLoading, setIsCPLoading] = useState(false);
    const [colleges, setColleges] = useState([]);
    const [isLimitExceed, setIsLimitExceed] = useState(false);
    // [
    //     { "$id": "3", "collegeCode": "3012", "college": "Veermata Jijabai Technological Institute(VJTI), Matunga, Mumbai", "abbreviatedName": "VJTI, Mumbai", "category": "GOPENS", "rank": "119", "percentile": "99.9456266", "branch": "Computer Engineering", "branchCode": "301224510", "si": "60" },
    //     { "$id": "4", "collegeCode": "16006", "college": "COEP Technological University", "abbreviatedName": "COEP, Pune", "category": "LOPENS", "rank": "451", "percentile": "99.8222067", "branch": "Computer Science and Engineering", "branchCode": "1600624210", "si": "300" },
    //     { "$id": "5", "collegeCode": "3036", "college": "Institute of Chemical Technology, Matunga, Mumbai", "abbreviatedName": "ICT, Mumbai", "category": "GOPENS", "rank": "1049", "percentile": "99.6526838", "branch": "Pharmaceuticals Chemistry and Technology", "branchCode": "303651310", "si": "18" }
    // ])
    const handleSubmit = async () => {
        // if (validateFields()) {
        let FeatureKey = "college_predictor"
        const payload = {
            "Name": name,
            "Email": email,
            "Mobile": mobile,
            FeatureKey,
            "Percentile": CPFiltersValues?.rank,
            "Branch": CPFiltersValues?.preferredBranch,
            "City": CPFiltersValues?.locationPreference
        };

        try {
            setIsCPLoading(true);
            let resp = await axios.post(`${configUrl.AssessmentServer}/api/User/FeatureRecord`, payload);
            // {
            //     CPFiltersValues?.rank && setColleges([
            //         { "$id": "3", "collegeCode": "3012", "college": "Veermata Jijabai Technological Institute(VJTI), Matunga, Mumbai", "abbreviatedName": "VJTI, Mumbai", "category": "GOPENS", "rank": "119", "percentile": "99.9456266", "branch": "Computer Engineering", "branchCode": "301224510", "si": "60" },
            //         { "$id": "4", "collegeCode": "16006", "college": "COEP Technological University", "abbreviatedName": "COEP, Pune", "category": "LOPENS", "rank": "451", "percentile": "99.8222067", "branch": "Computer Science and Engineering", "branchCode": "1600624210", "si": "300" },
            //         { "$id": "5", "collegeCode": "3036", "college": "Institute of Chemical Technology, Matunga, Mumbai", "abbreviatedName": "ICT, Mumbai", "category": "GOPENS", "rank": "1049", "percentile": "99.6526838", "branch": "Pharmaceuticals Chemistry and Technology", "branchCode": "303651310", "si": "18" }
            //     ])
            // }
            if (resp?.data?.allowed === false) {
                console.log(resp?.data?.allowed, 'falsy')
                setIsLimitExceed(true)
                setIsCPLoading(false)
                return
            }
            console.log(resp?.data?.allowed, 'validated')
            setColleges(resp?.data?.colleges["$values"]);
            setIsCPLoading(false)
            // if (resp.data?.allowed == true) {
            //     setOpen(true);
            //     console.log("Thanks! Please check your email for your personalized college list.");
            //     setSeverty('success');
            // } else {
            //     setOpen(true);
            //     console.log("Oh! Please subscribe to the College Predictor feature to receive updates and alerts throughout the admission process.");
            //     setSeverty('warning');
            // }
        } catch (error) {
            console.error("Error saving data:", error);
            setIsCPLoading(false);
        }
        // }
    };
    useEffect(() => {
        if (CPFiltersValues?.rank && CPFiltersValues?.preferredBranch && CPFiltersValues?.locationPreference) {
            handleSubmit()
        }
    }, [CPFiltersValues])

    const availableCoupons = course?.coupons?.$values || [];
    const bestCoupon = availableCoupons?.length
        ? availableCoupons.reduce((prev, curr) =>
            (curr?.discountPercentage || 0) > (prev?.discountPercentage || 0) ? curr : prev
        )
        : null;
    const handleQuickApplyCoupon = async (couponCode) => {
        setCoupon(couponCode);
        await handleApplyCoupon(null, couponCode);
    };


    const handleApplyCoupon = async (e, couponCodeOverride = null) => {
        e?.preventDefault();
        setIsLoading(true);
        try {
            const couponToApply = couponCodeOverride ?? coupon;
            if (!couponToApply) {
                setError("Please enter a coupon code");
                setIsLoading(false);
                return;
            }
            const applyCouponData = await applyCouponService.applyCoupon(couponToApply);

            if (applyCouponData.message === "Coupon code not found") {
                setDiscount(0);
                setError("Invalid coupon code");
                return;
            } else if (applyCouponData?.providerId && applyCouponData?.providerId !== configUrl.MediNeerProviderId) {
                setDiscount(0);
                setError("Coupon Expired.");
                return;
            }
            else if (applyCouponData?.isActive === false) {
                setDiscount(0);
                setError("Coupon Expired.");
                return;
            } else if (applyCouponData?.validFrom || applyCouponData?.validTo) {

                let valid = true;

                const now = new Date();
                now.setHours(0, 0, 0, 0); // Reset current time to midnight

                if (applyCouponData?.validFrom) {
                    const validFromDate = new Date(applyCouponData.validFrom);
                    validFromDate.setHours(0, 0, 0, 0); // Reset validFrom date to midnight
                    console.log("validFromDate", validFromDate, now);

                    if (now < validFromDate) {
                        valid = false; // Current date is before the validFrom date
                        console.log("validFrom check failed");
                    }
                }

                if (applyCouponData?.validTo) {
                    const validToDate = new Date(applyCouponData.validTo);
                    validToDate.setHours(0, 0, 0, 0); // Reset validTo date to midnight
                    console.log("validToDate", validToDate, now);

                    if (now > validToDate) {
                        valid = false; // Current date is after the validTo date
                        console.log("validTo check failed");
                    }
                }

                if (!valid) { // If not valid
                    setDiscount(0);
                    setError("Coupon Expired.");
                    return;
                }
            }


            if (applyCouponData?.resourceId && applyCouponData?.resourceId !== course?.courseId) {
                setDiscount(0);
                setError("Invalid coupon code");
                return;
            }

            if (applyCouponData?.discountPercentage) {
                setCouponID(applyCouponData?.id);
                setDiscount(applyCouponData?.discountPercentage);
                setError("");
            }
        } catch (error) {
            console.error("Error occurred", error);
            if (error?.response?.status === 404) {
                setDiscount(0);
                setError("Invalid coupon code");
                return;
            }
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    //const finalPrice = course?.price - (course?.price * discount) / 100;
    const finalPrice = course?.price ? course.price - (course.price * discount) / 100 : 0;
    const savings = course?.price ? (course.price * discount) / 100 : 0;
    const floatingHeadHeadWait = {
        float: "left",
        textAlign: "center",
        borderRadius: "2px",
        padding: "5px",
        height: "66px",
        width: "71px",
        margin: "5px",
        background: "#d3f3f7",
        color: "#594e4e",
        fontFamily: "Poppins",
        fontSize: "12px",
        display: "grid",
        lineHeight: "normal",
        alignItems: "center",
    };
    return (
        <Box
            sx={{
                padding: 3,
                maxWidth: 600,
                margin: "auto",
                backgroundColor: "#f9f9f9", // Light grey background for the whole component
                borderRadius: 2,
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)", // Subtle shadow for better aesthetics
            }}
        >

            {!isCPLoading && colleges?.length > 0 && (<Box sx={{ mb: 3 }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        mb: 1.5,
                        fontSize: "1.5rem",
                    }}
                >
                    Opportunities
                </Typography>

                {isCPLoading ? <Box sx={{ textAlign: 'center', marginTop: 5, marginBottom: 5 }}>Loading...</Box> : <Grid container spacing={1}>
                    {colleges && colleges?.map((college, index) => (
                        <Grid item xs={12} key={index} >
                            <Card
                                elevation={3}
                                sx={{
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    position: "relative",
                                    filter: index === 0 ? "none" : "blur(4px)",
                                    pointerEvents: index === 0 ? "auto" : "none",
                                    userSelect: index === 0 ? "auto" : "none",
                                    transition: "0.3s ease",
                                }}
                            >
                                {/* Top Banner */}
                                <div style={floatingHeadHeadWait}>
                                    <div>{college.category}</div>
                                    <div>{college["rank"]}</div>
                                    <div className="percentileText">
                                        {`${parseFloat(college["percentile"]).toFixed(2)}`}
                                    </div>

                                </div>

                                <CardContent sx={{
                                    pb: 0,
                                    "&:last-child": {
                                        pb: 0,
                                    },
                                }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 600,
                                            fontFamily: "Poppins",
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        {college.abbreviatedName || college.college} (
                                        {college["collegeCode"]})
                                    </Typography>

                                    <Typography
                                        color="text.secondary"
                                        sx={{
                                            // mt: 1,
                                            fontFamily: "Poppins",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {college.branch} ({college["branchCode"]})
                                    </Typography>

                                    <Typography
                                        sx={{
                                            // mt: 1, 
                                            fontFamily: "Poppins",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        Overall Seats: <b>{college.si}</b>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                    {/* <Grid item xs={12} textAlign={"center"}>
                        <Button
                            variant="contained"
                            size="large"
                            // onClick={() => onProceedToPayment({ couponID, finalPrice })}
                            sx={{
                                textTransform: "none",
                                fontSize: "1.4rem",
                                color: '#fff',
                                background: '#012248 !important',
                                fontFamily: 'Poppins',
                                //fontWeight: "bold",
                                '&:hover': {
                                    backgroundColor: '#012248 !important',
                                },
                            }}
                        >
                            <LockOpenIcon color="#fff" />&nbsp; See More...
                        </Button>
                    </Grid> */}
                </Grid>}
            </Box>)}

            <Box sx={{ mb: 2 }}>
                <Typography variant="h4" sx={{ fontSize: "2.1rem", fontWeight: "bold", fontFamily: 'Poppins' }}>
                    {CPFiltersValues?.rank ? null : course?.text || course?.courseName}
                    {
                        course?.subscriptionTypeId === 2 ?
                            // null :
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: "1.4rem", color: '#012248', mt: 1 }} >
                                {
                                    CPFiltersValues?.rank && isCPLoading && ("Loading...")
                                }
                                {CPFiltersValues?.rank && isLimitExceed && ("You've reached the limit of 3 free predictions. Subscribe to continue making predictions.")}

                                {CPFiltersValues?.rank ? <Typography variant="h5" sx={{ fontSize: "1.3rem", fontWeight: "bold", fontFamily: 'Poppins' }}> Don’t Just Browse. Get Real Admission Insights Now. </Typography> :
                                    null
                                    // "Congratulations for your achievement!"
                                }
                                {/* Apply Code <span style={{ color: "green", fontWeight: "bold" }}>MEDINEER2025</span> to get 10% off. */}
                            </Typography> :
                            <Typography variant="body1" sx={{ fontFamily: 'Poppins' }} >
                                {/* 
                                    Have a coupon or discount?
                                        <br />
                                    Only <span style={{ color: "red", fontWeight: "bold" }}>1 coupon</span> can be applied. 
                                */}
                            </Typography>
                    }
                    {bestCoupon && discount === 0 && (
                        <Box
                            sx={{
                                mt: 1,
                                p: 1.5,
                                backgroundColor: "#fff",
                                borderRadius: 1,
                                border: "1px dashed #4caf50",
                                fontFamily: "Poppins",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            {/* Coupon Info on the left */}
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: "1.4rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        color: "#EC9706",
                                        letterSpacing: "1px",
                                        mb: 0.3,
                                    }}
                                >
                                    Try this coupon {bestCoupon?.couponCode}
                                </Typography>

                                <Typography sx={{ fontSize: "1.2rem", fontFamily: "Poppins", color: "#EC9706" }}>
                                    Save {bestCoupon?.discountPercentage}% on this course
                                </Typography>
                            </Box>

                            {/* Apply button on the right */}
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleQuickApplyCoupon(bestCoupon?.couponCode)}
                                sx={{
                                    textTransform: "none",
                                    fontSize: "1.2rem",
                                    fontFamily: "Poppins",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    backgroundColor: "#EC9706",
                                    '&:hover': { backgroundColor: "#c37d05" },
                                }}
                            >
                                Apply
                            </Button>
                        </Box>
                    )}



                </Typography>
                {/* <Typography
                    variant="h5"
                    color="text.secondary"
                    sx={{ fontSize: "1.6rem" }}
                >
                    Original Price: ₹{course?.price || 0}
                </Typography> */}
            </Box>
            {/* <Divider sx={{ my: 1 }} /> */}
            {/* <Typography variant="h6" gutterBottom sx={{ fontSize: "1.4rem" }}>
                Apply Coupon
            </Typography> */}
            {/* comment this for hide coupen section */}
            {/* <Grid container spacing={2} alignItems="center">
                <Grid item xs={8}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                        size="small"
                        placeholder="Enter Coupon Code"
                        sx={{
                            mb: 1,
                            fontFamily: 'Poppins',
                            "& .MuiInputBase-input": { fontSize: "1.5rem" },
                            "& .MuiFormHelperText-root": {
                                fontSize: "1.2rem", // Increased helper text size
                            },
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                        InputLabelProps={{ shrink: false }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        // color="primary"
                        fullWidth
                        onClick={handleApplyCoupon}
                        disabled={isLoading || isFreeSubscription === true}
                        size="medium"
                        sx={{
                            textTransform: "none", fontSize: "1.3rem", fontFamily: 'Poppins', color: '#fff', background: '#012248 !important',
                            '&:hover': {
                                backgroundColor: '#012248 !important', // Keep the background color the same on hover
                            },
                        }}
                        style={{ marginBottom: "7px", }}
                    >
                        {isLoading ? <CircularProgress size={24} /> : "Apply"}
                    </Button>
                </Grid>
            </Grid> */}
            {error && (
                <Alert severity="error" sx={{ mt: 1, fontSize: "1rem", fontFamily: 'Poppins' }}>
                    {error}
                </Alert>
            )}
            {discount > 0 && (
                <Alert severity="success" sx={{ mt: 1, fontSize: "1rem", fontFamily: 'Poppins' }}>
                    Coupon applied! You saved ₹{savings.toFixed(2)}.
                    <Button
                        variant="text"
                        //color="inherit"
                        size="small"
                        onClick={() => {
                            setCoupon("");
                            setDiscount(0);
                            setCouponID(null);
                        }}
                        sx={{
                            ml: 2,
                            textTransform: "none",
                            fontSize: "1.2rem",
                            fontWeight: "bold", fontFamily: 'Poppins'
                        }}
                    >
                        Remove
                    </Button>
                </Alert>
            )}
            <Divider sx={{ my: 2 }} />
            {CPFiltersValues?.rank ? null : <Box
                sx={{
                    mb: 2,
                    p: 2,
                    backgroundColor: "#e0e0e0", // Light grey background for order summary
                    borderRadius: 1,
                    fontFamily: 'Poppins'
                }}
            >
                <Typography variant="h6" sx={{ fontSize: "1.6rem", fontWeight: "bold", fontFamily: 'Poppins' }}>
                    Order Summary
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: "1.3rem", fontFamily: 'Poppins' }}>Total MRP</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Typography sx={{ fontSize: "1.3rem", fontFamily: 'Poppins' }}>₹{course?.price || 0}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: "1.3rem", fontFamily: 'Poppins' }}>Coupon Discount:</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Typography sx={{ fontSize: "1.3rem" }}>
                            - ₹{savings.toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: "1.3rem", fontWeight: "bold", fontFamily: 'Poppins' }}>
                            Amount Payable
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Typography sx={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                            ₹{finalPrice.toFixed(2)}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>}
            <Button
                variant="contained"
                // color="secondary"
                fullWidth
                size="large"
                onClick={() => onProceedToPayment({ couponID, finalPrice })}
                sx={{
                    textTransform: "none",
                    fontSize: "1.4rem",
                    color: '#fff',
                    background: '#012248 !important',
                    fontFamily: 'Poppins',
                    //fontWeight: "bold",
                    '&:hover': {
                        backgroundColor: '#012248 !important', // Keep the background color the same on hover
                    },
                }}
            >
                {CPFiltersValues?.rank ? "Subscribe College Predictor @ ₹ 1000 " : (isFreeSubscription === true ? "Claim free subscription" : "Proceed to Payment")}
            </Button>
        </Box>

    );
};

export default CheckoutPage;
